import { createContext } from 'react';

import type { PageLoadData } from './types';

export interface PageDataLoadContextValue {
  readonly pageLoadData: PageLoadData;
}

export const PageDataLoadContext = createContext<PageDataLoadContextValue | undefined>(undefined);
